import React from 'react';
import { Link } from 'react-router-dom';
import { FiLogOut, FiMenu, FiMoon, FiSun, FiUser } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';

export default function NavBar({ onToggleSidebar, isSidebarCollapsed, onOpenMobileMenu }) {
  const { user, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();

  return (
    <header className="app-navbar">
      <div className="app-navbar-left">
        <button
          type="button"
          className="navbar-icon-btn navbar-mobile-only"
          onClick={onOpenMobileMenu}
          aria-label="Open sidebar menu"
        >
          <FiMenu />
        </button>

        <button
          type="button"
          className="navbar-icon-btn navbar-desktop-only"
          onClick={onToggleSidebar}
          aria-label={isSidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          title={isSidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          <FiMenu />
        </button>

        <div className="navbar-title-wrap">
          <p className="navbar-eyebrow">RMC2 Findesk</p>
          <h1 className="navbar-title">Financial Management System</h1>
        </div>
      </div>

      <div className="app-navbar-right">
        <button
          type="button"
          className="navbar-icon-btn"
          onClick={toggleTheme}
          aria-label="Toggle theme"
          title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          {theme === 'dark' ? <FiSun /> : <FiMoon />}
        </button>

        <Link to="/profile" className="navbar-profile-link">
          <FiUser />
          <span>{user?.full_name || user?.username || 'Profile'}</span>
        </Link>

        <button type="button" className="navbar-logout-btn" onClick={logout}>
          <FiLogOut />
          <span>Logout</span>
        </button>
      </div>
    </header>
  );
}
